// extracted by mini-css-extract-plugin
module.exports = {"infoCard":"InfoCard_infoCard__zco9N","infoCardHeader":"InfoCard_infoCardHeader__mOxzJ"};